export default { sha: 'a36b1a44836f87165a2b550e95be50b15522d645', buildNumber: 'undefined' }
